import { ConnectionsSlice } from '../types/connections';

export const initialState: ConnectionsSlice = {
    profiles: [],
    isLoadingProfiles: true,
};

export default initialState;
